"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMarkActivityKeyAsRead;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useMarkActivityKeyAsRead() {
  return (0, _useContext.default)().markActivityKeyAsRead;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VNYXJrQWN0aXZpdHlLZXlBc1JlYWQiLCJ1c2VBY3Rpdml0eUFja25vd2xlZGdlbWVudENvbnRleHQiLCJtYXJrQWN0aXZpdHlLZXlBc1JlYWQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcm92aWRlcnMvQWN0aXZpdHlBY2tub3dsZWRnZW1lbnQvdXNlTWFya0FjdGl2aXR5S2V5QXNSZWFkLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VBY3Rpdml0eUFja25vd2xlZGdlbWVudENvbnRleHQgZnJvbSAnLi9wcml2YXRlL3VzZUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VNYXJrQWN0aXZpdHlLZXlBc1JlYWQoKTogKGFjdGl2aXR5S2V5OiBzdHJpbmcpID0+IHZvaWQge1xuICByZXR1cm4gdXNlQWN0aXZpdHlBY2tub3dsZWRnZW1lbnRDb250ZXh0KCkubWFya0FjdGl2aXR5S2V5QXNSZWFkO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSx3QkFBVCxHQUFtRTtFQUNoRixPQUFPLElBQUFDLG1CQUFBLElBQW9DQyxxQkFBM0M7QUFDRCJ9